export const CONFIG = {
  beastRoot: "https://beast.sdslabs.co/server",
  staticRoot: "https://beast.sdslabs.co/server/",
  webRoot: "http://3.111.71.217",
  ncRoot: "3.111.71.217"
};
